import IndexPage from '@/pages/index.vue';
import DashboardPersonal from '@/pages/dashboardPersonal.vue';
import Bloqueos from '@/pages/bloqueos.vue';
import MiCuenta from '@/pages/MiCuenta.vue';
import Dashboard from '@/pages/Dashboard.vue';
import pendingRisks from '@/pages/pendingRisks.vue';
import LoginPage from '@/pages/LoginPage.vue';
import PermissionDeniedPage from '@/pages/PermissionDeniedPage.vue';
import SelectRoles from '@/pages/SelectRoles.vue';
import AdminPage from '@/pages/admin/AdminPage.vue';
import ListWorkflows from '@/pages/admin/workflows/List.vue';
import WelcomePage from '@/pages/admin/WelcomePage.vue';
import ImportPage from '@/pages/admin/ImportPage.vue';
import AccountPage from '@/pages/AccountPage.vue';
import CreateWorkflow from '@/pages/admin/workflows/Create.vue';
import summaryUser from '@/pages/summaryUser.vue';
import autoCreacionStep0 from '@/pages/autoCreacionStep0.vue';
import recoveryPassword0 from '@/pages/recoveryPassword0.vue';
import Soporte from '@/pages/Soporte.vue';
import autoCreacionStep2 from '@/pages/autoCreacionStep2.vue';
import autoCreacionStep3 from '@/pages/autoCreacionStep3.vue';
import buscarContrato from '@/pages/buscarContrato.vue';
import accountSuccess from '@/pages/accountSuccess.vue';
import asignarRol from '@/pages/asignarRol.vue';

import ReportIndex from '@/pages/admin/reports/Index.vue';

// Usuarios
import AdminUsersPage from '@/pages/admin/users/Index.vue';

// Areas
import AdminAreasPage from '@/pages/admin/areas/Index.vue';

// Empresas
import AdminCompaniesPage from '@/pages/admin/companies/List.vue';

// Contratos
import AdminContractsPage from '@/pages/admin/contracts/List.vue';
import ContractCreateStep1 from '@/pages/admin/contracts/create/Step1.vue';
import ContractCreateStep2 from '@/pages/admin/contracts/create/Step2.vue';
import ContractCreateStep3 from '@/pages/admin/contracts/create/Step3.vue';

// Inventarios
import InventorySelectPage from '@/pages/inventories/Select.vue';
import InventoryShowPage from '@/pages/inventories/Show.vue';
import InventoryEditPage from '@/pages/inventories/Edit.vue';
import InventoryCheckPage from '@/pages/inventories/Check.vue';

import InventoryEditTaskStep1 from '@/pages/inventories/tasks/Step1.vue';
import InventoryEditTaskStep2 from '@/pages/inventories/tasks/Step2.vue';
import InventoryEditTaskStep3 from '@/pages/inventories/tasks/Step3-Summary.vue';

// Riesgos estandarizados
import RisksList from '@/pages/risks/List.vue';

import pushIndex from '@/pages/pushIndex.vue';

// i18n
import { Trans } from '@/helpers/i18n';
import RouterWrapper from '@/pages/RouterWrapper.vue';

// procedures
import UpdateContractRoles from '@/pages/admin/UpdateContractRoles.vue';

export default [{
  path: '/:lang',
  name: 'languageRoute',
  component: RouterWrapper,
  beforeEnter: Trans.routeMiddleware,
  children: [
  {
    path: 'pushIndex',
    name: 'pushIndex',
    component: pushIndex,
  },
  {
    path: '',
    name: 'homePage',
    component: IndexPage,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'summary-user',
    name: 'summaryUser',
    component: summaryUser,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'auto-creacion-step0',
    name: 'autoCreacionStep0',
    component: autoCreacionStep0,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'recovery-password-0',
    name: 'recoveryPassword0',
    component: recoveryPassword0,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'auto-creacion-step2',
    name: 'autoCreacionStep2',
    component: autoCreacionStep2,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'auto-creacion-step3',
    name: 'autoCreacionStep3',
    component: autoCreacionStep3,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'buscar-contrato',
    name: 'buscarContrato',
    component: buscarContrato,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'auto-creacion-success',
    name: 'accountSuccess',
    component: accountSuccess,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'dashboard-personal',
    name: 'dashboardPersonal',
    component: DashboardPersonal,
  },
  {
    path: 'bloqueos',
    name: 'bloqueos',
    component: Bloqueos,
  },
  {
    path: 'mi-cuenta',
    name: 'MiCuenta',
    component: MiCuenta,
  },
  {
    path: 'pending-risks',
    name: 'riesgosPendientes',
    component: pendingRisks,
  },
  {
    path: 'permiso-denegado',
    name: 'permisoDenegado',
    component: PermissionDeniedPage,
    meta: {
      layout: 'blank',
    },
  },
  {
    path: 'login',
    name: 'login',
    component: LoginPage,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      layout: 'login',
    },
  },
  {
    path: 'admin',
    name: 'admin',
    component: AdminPage,
    meta: {
      requiresAuth: true,
    },
    children: [{
      path: 'welcome',
      name: 'welcome',
      component: WelcomePage,
    },
    {
      path: 'soporte',
      name: 'Soporte',
      component: Soporte,
    },
    {
      path: 'asignarRol',
      name: 'asignarRol',
      component: asignarRol,
    },
    {
      path: 'usuarios',
      name: 'usuarios',
      component: AdminUsersPage,
    },
    {
      path: 'empresas',
      name: 'empresas',
      component: AdminCompaniesPage,
    },
    {
      path: 'contratos/crear/paso1',
      name: 'contractCreateStep1',
      component: ContractCreateStep1,
    },
    {
      path: 'contratos/crear/paso2',
      name: 'contractCreateStep2',
      component: ContractCreateStep2,
    },
    {
      path: 'contratos/crear/paso3',
      name: 'contractCreateStep3',
      component: ContractCreateStep3,
    },
    {
      path: 'contratos',
      name: 'listContracts',
      component: AdminContractsPage,
    },
    {
      path: 'import',
      name: 'importacion',
      component: ImportPage,
    },
    {
      path: 'UpdateContractRoles',
      name: 'UpdateContractRoles',
      component: UpdateContractRoles,
    },
    {
      path: 'workflow/create',
      name: 'createWorkflow',
      component: CreateWorkflow,
    },
    {
      path: 'reports',
      name: 'reportIndex',
      component: ReportIndex,
    }
    ],
  },
  {
    path: 'areas',
    name: 'areas',
    component: AdminAreasPage,
  },
  {
    path: 'workflows',
    name: 'workflows',
    component: ListWorkflows,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'riesgos-estandarizados',
    name: 'standarized-risks',
    component: RisksList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/tareas/paso1',
    name: 'firstStep',
    component: InventoryEditTaskStep1,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/tareas/paso2',
    name: 'secondStep',
    component: InventoryEditTaskStep2,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/tareas/step3',
    name: 'summaryStep',
    component: InventoryEditTaskStep3,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'mi-cuenta',
    name: 'cuenta',
    component: AccountPage,
    meta: {
      requiresAuth: true,
    },
  },
  // Multirroles
  {
    path: 'inventarios',
    name: 'inventorySelectPage',
    component: InventorySelectPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'seleccionar-roles',
    name: 'SelectRoles',
    component: SelectRoles,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/:contratoId/ver',
    name: 'inventoryShowPage',
    component: InventoryShowPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/:contratoId/editar',
    name: 'editInventoryPage',
    component: InventoryEditPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'inventario/:contratoId/revisar',
    name: 'checkInventoryPage',
    component: InventoryCheckPage,
    /* meta: {
                  requiresAuth: true,
                }, */
  },
  ],
},
{
  path: '*',
  redirect: Trans.getTranslatedRoute,
},
];
